import React from 'react';
import { motion } from 'framer-motion';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/3Uf3XB7zoeQYdkRgVom3Yr/ChatGPT_Image_5_feb_2026,_16_11_23.png';
export function HeroSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-121">
      <div className="container mx-auto max-w-2xl text-center" data-id="element-122">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center justify-center gap-3 text-green-700/80 font-semibold text-sm tracking-[0.2em] uppercase mb-8" data-id="element-123">
          <span className="w-10 h-px bg-green-400/50" data-id="element-124"></span>
          🌿 Aprende, Armoniza y Sana
          <span className="w-10 h-px bg-green-400/50" data-id="element-125"></span>
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mb-10" data-id="element-126">
          <span className="block text-5xl md:text-7xl lg:text-8xl font-extrabold tracking-tight leading-[0.9]" data-id="element-127">
            <span className="text-gray-900" data-id="element-128">Mega</span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-500 via-amber-600 to-amber-500" data-id="element-129">
              Pack
            </span>
          </span>
          <span className="block text-3xl md:text-4xl lg:text-5xl font-serif italic text-gray-600 mt-3" data-id="element-130">
            Reiki
          </span>
        </motion.h1>

        <motion.a href={HOTMART} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="block mx-auto max-w-sm mb-12 cursor-pointer group" data-id="element-131">
          <div className="relative" data-id="element-132">
            {/* Ambient glow behind image */}
            <div className="absolute -inset-6 bg-gradient-to-br from-amber-300/30 via-yellow-200/20 to-green-200/20 rounded-3xl blur-2xl opacity-60 group-hover:opacity-80 transition-opacity duration-500" data-id="element-133"></div>

            {/* Decorative frame */}
            <div className="relative bg-gradient-to-br from-amber-100 via-white to-amber-50 p-3 md:p-4 rounded-2xl shadow-[0_8px_60px_rgba(217,119,6,0.15)] group-hover:shadow-[0_12px_70px_rgba(217,119,6,0.25)] transition-all duration-500" data-id="element-134">
              {/* Corner ornaments */}
              <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-amber-400/50 rounded-tl-2xl" data-id="element-135"></div>
              <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-amber-400/50 rounded-tr-2xl" data-id="element-136"></div>
              <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-amber-400/50 rounded-bl-2xl" data-id="element-137"></div>
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-amber-400/50 rounded-br-2xl" data-id="element-138"></div>

              <img src={PRODUCT_IMG} alt="MegaPack Reiki - Camino Integral del Reiki" className="w-full rounded-xl shadow-inner" data-id="element-139" />
            </div>
          </div>
        </motion.a>

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-xl md:text-2xl font-serif font-bold text-gray-800 mb-5" data-id="element-140">
          Formación completa lista para iniciar
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="text-base md:text-lg text-gray-500 mb-8 leading-relaxed max-w-xl mx-auto" data-id="element-141">
          Todo el material de Reiki que necesitas, ordenado, claro y listo para
          usar, para comenzar tu camino de sanación personal o acompañar a
          otros.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="flex flex-wrap justify-center gap-6 mb-10 text-gray-600 font-semibold text-base" data-id="element-142">
          <span data-id="element-143">✔ Sin tecnicismos</span>
          <span data-id="element-144">✔ Sin cursos eternos</span>
        </motion.div>

        <motion.a href={HOTMART} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="inline-block px-10 py-5 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-xl md:text-2xl rounded-full shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_50px_rgba(245,158,11,0.6)] transition-all" data-id="element-145">
          👉 SÍ, QUIERO ACCEDER AHORA
        </motion.a>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="mt-4 text-green-600 font-medium text-sm" data-id="element-146">
          ✅ Garantía de satisfacción de 7 días
        </motion.p>
      </div>
    </section>;
}